import { __awaiter, __extends, __generator } from "tslib";
import Resource from './resource';
import EducationModel from '../models/education';
var EducationModule = (function (_super) {
    __extends(EducationModule, _super);
    function EducationModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EducationModule.prototype.fetchDrugInformation = function (params) {
        return this.client.http.get("/education/monographs", { params: params }).then(function (_a) {
            var data = _a.data;
            return data.data;
        });
    };
    EducationModule.prototype.fetchEducation = function (educationId) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.client.http.get("/education/" + educationId)];
                    case 1:
                        data = (_a.sent()).data.data;
                        return [2, new EducationModel(data, this.client)];
                }
            });
        });
    };
    return EducationModule;
}(Resource));
export default EducationModule;
//# sourceMappingURL=education.js.map